import React, { useEffect } from 'react'
import { arrowright, ecare, kodecamp, orderme, projline, whiteStar } from '../../assets/images'



const projects: { name: string, info: string, img: any, swap?: boolean }[] = [{
  name: 'E-Care Mobile App/ Website   ',
  info: "E-care focuses on achieving SDGs goal number three (good health and well-being). This app contains two main features namely:Health record management, which provides solution to hospital record mismanagement, andRural-connect, which focuses on extending good health care to rural dwellers. ",
  img: ecare
}, {
  name: "OrderMe App",
  info: "Orderme app looks to give customers a more seamless experience when making purchase of drinks and foods by making table reservations without having to go throughy the hurdles of queing at the counter. ",
  img: orderme,
  swap: true
}, {
  name: 'Kodecamp E-learning System',
  info: "An E-learning management system for Kodecamp designed to equip students with virtual access to the facilitators of the program as well as mentors who instucts their students while taking into consideration the marketable products and sponsporships Kodecamp are open to.",
  img: kodecamp
}
]

interface Props{
  effect: string[];
}
const Projects = (props:Props) => {



  return (
    <section id='Projects' className='lg:mt-[7.313rem] mt-5'>
      <div className='container md:pl-[61px] md:pr-[57px] p-[20px] relative'>


        <h1 className='text-[#A6B2EC] uppercase  text-[1.125rem] lg:text-[2.25rem] text-center bold relative'>Projects
          <img src={whiteStar} className="absolute animateStar  top-[100%] lg:left-[100%] left-[70%] md:w-auto w-[2%]" alt="blue star" />

        </h1>
{/* data-aos={props.effect[0]}  */}
        <div className='lg:flex justify-between text-white gap-5 mt-[24px] lg:mt-[12.063rem] flex-wrap text-center lg:text-left relative mb-[44px]'>
          <img   src={projline} className="absolute sm:h-auto h-[300px] left-[-10%] rotate-[20deg] z-[-1] " alt="" />

          <div className={`circle absolute lg:top-[10%] top-[70%] translate-x-[-50%] sm:right-[-20%] right-[-60%] z-[-1] bg-[#FE0000] rounded-full `}></div>
          <div className={`circle absolute top-[0%] translate-x-[-50%] left-[0%] z-[-1] bg-[#3971E7] rounded-full `}></div>


          <img data-aos={props.effect[0]} className={`lg:w-[45%] z-[2] sm:w-[70%]  lg:m-0 m-auto`} src={projects[0].img} alt={projects[0].name} />

          <div className={`lg:w-[40%] sm:w-[70%] lg:mt-0 md:my-[6rem]  mt-[2.75rem] flex lg:mx-0 mx-auto`}>

            <div data-aos={props.effect[1]} className='m-auto'>
              <header className='bold text-[1.125rem] md:text-[1.5rem]' >{projects[0].name}</header>
              <p className='light  text-[0.75rem] mt-[17px] leading-[35px] md:text-[0.875rem]'>{projects[0].info}</p>
              <button className='bold hover:text-[#81B8FF] lg:text-[1.25rem] text-[0.875rem] mt-[64px]'>
                <span className='transition-all hover:mr-[16px]'>View case study</span>  <img src={arrowright} className="inline w-[20px] h-[20px] " alt="arrow right" /></button>
            </div>
          </div>
        </div>


        <div className='lg:flex justify-between text-white gap-5 mt-[24px] lg:mt-[12.063rem] flex-wrap text-center lg:text-left mb-[44px] relative right-0'>
{/* data-aos={props.effect[1]} */}
          <img src={projline}  className="absolute sm:h-auto h-[300px] xl:top-[-80%] lg:top-[-70%] md:top-[-17%] sm:top-[-15%] top-[-80px] rotate-[20deg] right-[-8%] z-[-1]" alt="" />
          <div className={`circle absolute top-[-30%] lg:block hidden translate-x-[-50%]  right-[-20%] z-[1] bg-[#3971E7] rounded-full `}></div>

          <div className={`circle absolute bottom-[-30%] lg:block hidden  right-[-5%] z-[1] bg-[#3971E7] rounded-full `}></div>

          <img data-aos="fade-left" className={`lg:w-[45%] z-[2] sm:w-[70%] order-2 lg:m-0 m-auto`} src={projects[1].img} alt={projects[1].name} />

          <div data-aos={props.effect[0]} className={`lg:w-[40%] sm:w-[70%] lg:mt-0 md:my-[6rem]  mt-[2.75rem] relative flex lg:mx-0 mx-auto`}>
            <div className={`circle absolute top-[0%] translate-x-[-50%] left-[0%] z-[-1] bg-[#3971E7] rounded-full `}></div>

            <div className='m-auto'>
              <header className='bold text-[1.125rem] md:text-[1.5rem]' >{projects[1].name}</header>
              <p className='light  text-[0.75rem] mt-[17px] leading-[35px] md:text-[0.875rem]'>{projects[1].info}</p>
              <button className='bold hover:text-[#81B8FF] lg:text-[1.25rem] text-[0.875rem] mt-[64px]'>
                <span className='transition-all hover:mr-[16px]'>View case study</span>  <img src={arrowright} className="inline w-[20px] h-[20px] " alt="arrow right" /></button>
            </div>

          </div>



        </div>



        <div className='lg:flex justify-between text-white gap-5 mt-[24px] lg:mt-[12.063rem] flex-wrap text-center lg:text-left mb-[44px] relative'>
          <img src={projline} className="absolute sm:h-auto h-[300px] left-[-10%] top-[35%] rotate-[20deg] z-[-1] " alt="" />

          <div className={`fadedCircle absolute top-[-10%]  right-0 z-[-1] bg-[#FE0000] rounded-full `}></div>
          <div className={`circle absolute lg:top-[85%] top-[45%]  right-[0%] lg:right-[10%] z-[-1] bg-[#3971E7] rounded-full `}></div>
          <div className={`fadedCircle absolute lg:top-[100%] top-[60%] right-[5%] lg:right-[-5%] z-[-1] bg-[#FE0000] rounded-full `}></div>

          <img data-aos={props.effect[0]} className={`lg:w-[45%] z-[2] sm:w-[70%]  lg:m-0 m-auto`} src={projects[2].img} alt={projects[2].name} />

          <div data-aos={props.effect[1]} className={`lg:w-[40%] sm:w-[70%] lg:mt-0 md:my-[6rem]  mt-[2.75rem] flex lg:mx-0 mx-auto`}>
            <div className='m-auto'>
              <header className='bold text-[1.125rem] md:text-[1.5rem]' >{projects[2].name}</header>
              <p className='light  text-[0.75rem] mt-[17px] leading-[35px] md:text-[0.875rem]'>{projects[2].info}</p>
              <button className='bold hover:text-[#81B8FF] lg:text-[1.25rem] text-[0.875rem] mt-[64px]'>
                <span className='transition-all hover:mr-[16px]'>View case study</span>  <img src={arrowright} className="inline w-[20px] h-[20px] " alt="arrow right" /></button>
            </div>
          </div>
        </div>

        <div className='text-center md:mt-[8rem]'>
          <button className='mx-auto underline lg:text-[1.25rem] text-[1.125rem] text-white bold'>More projects</button>
        </div>

      </div>
    </section>
  )
}

export default Projects